// Updates <meta name="robots"> for every route change
// Uses route.meta.robots as value and fallbacks to
// "noindex, nofollow"

import { RouteLocationNormalized } from "vue-router";

const DEFAULT_META_ROBOTS = "noindex, nofollow";

const getMetaRobotsElement = () => {
  let el = document.querySelector('meta[name="robots"]');
  if (el) return el;
  el = document.createElement("meta");
  el.setAttribute("name", "robots");
  document.head.appendChild(el);
  return el;
};

export default (to: RouteLocationNormalized): void => {
  const metaRobotsElement = getMetaRobotsElement();
  metaRobotsElement.setAttribute(
    "content",
    (to?.meta?.robots as string) || DEFAULT_META_ROBOTS
  );
};
